"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // import * as CryptoJS from 'crypto-js'

var forge = require("node-forge");

var base58_1 = require("../libs/base58");

var param_1 = require("./param");

var string_bytes_1 = require("./string-bytes");

exports.base64Decode = function (input) {
  return string_bytes_1.stringToBytes(forge.util.decode64(input), 'raw');
};

exports.base64Encode = function (input) {
  return forge.util.encode64(string_bytes_1.bytesToString(param_1._fromIn(input), 'raw'));
};

exports.base58Decode = function (input) {
  return base58_1.default.decode(input);
};

exports.base58Encode = function (input) {
  return base58_1.default.encode(param_1._fromIn(input));
};

exports.base16Decode = function (input) {
  return string_bytes_1.stringToBytes(forge.util.hexToBytes(input), 'raw');
};

exports.base16Encode = function (input) {
  return forge.util.bytesToHex(string_bytes_1.bytesToString(param_1._fromIn(input), 'raw'));
};